import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { IoCloseCircleSharp } from "react-icons/io5";
import { IoChevronBack, IoChevronForward } from "react-icons/io5"; // arrows
import image1 from "../../Assets/Images/RealEstate.png";
import image2 from "../../Assets/Images/Ecommerce2.png";
import image3 from "../../Assets/Images/ERP.png";
import image4 from "../../Assets/Images/RegNotice.png";
import image5 from "../../Assets/Images/CargoService.png";
import image6 from "../../Assets/Images/TaskManagementImage.png";
import image7 from "../../Assets/Images/ConstructionManagementImage.png";
import image8 from "../../Assets/Images/TrackingSoftware.png";

const images = [
  image1, image2, image3, image4,
  image5, image6, image7, image8,
];

const ProductResponsive = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(1); // start from 1 (first real slide)
  const carouselRef = useRef(null);

  const extendedImages = [images[images.length - 1], ...images, images[0]]; 
  // clones: last + all + first

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-scroll
  useEffect(() => {
    if (!isMobile) return;
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(interval);
  }, [isMobile, currentIndex]);

  // Slide to next
  const nextSlide = () => {
    setCurrentIndex((prev) => prev + 1);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => prev - 1);
  };

  // Sync scroll
  useEffect(() => {
    if (!carouselRef.current) return;
    const width = carouselRef.current.clientWidth;
    carouselRef.current.style.transition = "transform 0.6s ease-in-out";
    carouselRef.current.style.transform = `translateX(-${currentIndex * width}px)`;
  }, [currentIndex]);

  // Jump without transition when at clone
  const handleTransitionEnd = () => {
    const width = carouselRef.current.clientWidth;
    if (currentIndex === 0) {
      // jump to last real
      carouselRef.current.style.transition = "none";
      carouselRef.current.style.transform = `translateX(-${images.length * width}px)`;
      setCurrentIndex(images.length);
    } else if (currentIndex === images.length + 1) {
      // jump to first real
      carouselRef.current.style.transition = "none";
      carouselRef.current.style.transform = `translateX(-${width}px)`;
      setCurrentIndex(1);
    }
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index + 1);
  };

  const handleImageClick = (img) => setSelectedImage(img);
  const closeModal = () => setSelectedImage(null);

  return (
    <StyledWrapper isMobile={isMobile}>
      {!isMobile ? (
        // Desktop view (cards)
        <div className="container-items pb-20">
          {images.map((img, index) => (
            <button
              key={index}
              className="item-image"
              onClick={() => handleImageClick(img)}
            >
              <img src={img} alt={`img-${index}`} />
            </button>
          ))}
        </div>
      ) : (
        // Mobile/Tablet carousel
        <div className="carousel-wrapper">
          <div
            className="carousel"
            ref={carouselRef}
            onTransitionEnd={handleTransitionEnd}
          >
            {extendedImages.map((img, index) => (
              <div className="carousel-item" key={index}>
                <img
                  src={img}
                  alt={`img-${index}`}
                  onClick={() => handleImageClick(img)}
                />
              </div>
            ))}
          </div>

          {/* Arrows */}
          <button className="arrow left" onClick={prevSlide}>
            <IoChevronBack />
          </button>
          <button className="arrow right" onClick={nextSlide}>
            <IoChevronForward />
          </button>

          {/* Dots */}
          <div className="dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentIndex - 1 === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
      )}

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>
              <IoCloseCircleSharp />
            </button>
            <img src={selectedImage} alt="Full View" />
          </div>
        </div>
      )}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  /* Desktop Card Layout */
  .container-items {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .item-image {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 10px;

    img {
      width: 160px;
      height: 140px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }
  }

  /* Mobile/Tablet Carousel */
  ${(props) =>
    props.isMobile &&
    `
    .carousel-wrapper {
      position: relative;
      overflow: hidden;
      width: 100%;
    }

    .carousel {
      display: flex;
      transition: transform 0.6s ease-in-out;
    }

    .carousel-item {
      flex: 0 0 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .carousel-item img {
      width: 90%;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.25);
    }

    /* Arrows */
    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: #fff;            /* white background */
      border: 1px solid #ccc;      /* light gray border */
      color: #000;                 /* black arrow icon */
      font-size: 1.2rem;           /* balanced size */
      cursor: pointer;
      padding: 0.4rem;             /* more padding for round look */
      border-radius: 50%;          /* perfectly round */
      box-shadow: 0 2px 6px rgba(0,0,0,0.2); /* soft shadow */
      z-index: 10;
    }
    .arrow.left { left: 10px; }
    .arrow.right { right: 10px; }

    /* Dots */
    .dots {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      gap: 8px;
    }
    .dot {
      width: 10px;
      height: 10px;
      background: #fff; /* white dots */
      border: 1px solid #ccc; /* light gray border */
      border-radius: 50%;
      cursor: pointer;
      opacity: 0.6;
      transition: all 0.3s ease;
    }
    .dot.active {
      width: 16px;
      height: 16px;
      background: #fff; /* white active dot */
      border: 1px solid #333; /* darker border for active */
      opacity: 1;
    }
  `}

  /* Modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .modal-content {
    position: relative;
    background: #fff;
    padding: 1rem;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 70vh;
      border-radius: 6px;
    }

    .close-btn {
      position: absolute;
      top: 10px;
      right: 14px;
      border: none;
      font-size: 2rem;
      color: red;
      background: transparent;
      cursor: pointer;
    }
  }
`;

export default ProductResponsive;